import React, {useRef, useState} from "react";
import emailjs from "@emailjs/browser";
import {ToastContainer, toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {Tooltip} from "./Tooltip";
import {useTranslation} from "react-i18next";
import PhoneInput from "react-phone-input-2";

const Contact = ({classicHeader, darkTheme}) => {
    const {t} = useTranslation();
    const form = useRef();
    const [sendingMail, setSendingMail] = useState(false);
    const [first_name, setFirstName] = useState('');
    const [last_name, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile_number, setMobileNumber] = useState('');
    const [message, setMessage] = useState('');
    const [record_source] = useState('personal_web');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const sendEmail = (e) => {
        e.preventDefault();
        setSendingMail(true);
        const data = {
            "contact_message": {
                first_name,
                last_name,
                email,
                mobile_number,
                message,
                record_source
            }
        };
        fetch(process.env.REACT_APP_API_ENDPOINT, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        })
            .then(response => {
                response.json().then(r => r);
            })
            .then(data => {
                setIsSubmitting(false);
                setFirstName('');
                setLastName('');
                setEmail('');
                setMobileNumber('');
                setMessage('');
            })
            .catch(error => {
                console.error(error);
                setIsSubmitting(false);
            });
        emailjs
            .sendForm(
                process.env.REACT_APP_MAIL_SERVICE_ID,
                process.env.REACT_APP_MAIL_TEMPLATE_ID,
                form.current,
                process.env.REACT_APP_MAIL_PUBLIC_KEY
            )
            .then(
                (result) => {
                    setIsSubmitting(false);
                    document.getElementById("contact-form").reset();
                    toast.success("¡Gracias, mensaje enviado exitosamente!", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: darkTheme ? "dark" : "light",
                    });
                    console.log(result.text);
                    setSendingMail(false);
                },
                (error) => {
                    setIsSubmitting(true);
                    toast.error("¡Oops, algo salió mal!", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: darkTheme ? "dark" : "light",
                    });
                    console.log(error);
                    setSendingMail(false);
                }
            );
    };

    return (
        <section
            id="contact"
            className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
        >
            <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
                {/* Heading */}
                <div className="position-relative d-flex text-center mb-5">
                    <h2
                        className={
                            "text-24  text-uppercase fw-600 w-100 mb-0 " +
                            (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
                        }
                    >
                        {t("contact.title1")}
                    </h2>
                    <p
                        className={
                            "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
                            (darkTheme ? "text-white" : "text-dark")
                        }
                    >
                        {" "}
                        {t("contact.title2")}
                        <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto"/>
                    </p>
                </div>
                {/* Heading end*/}
                <div className="row gy-5">
                    {/* contact details */}
                    <div className="col-md-4 col-xl-3 order-1 order-md-0 text-center text-md-start">
                        <h2
                            className={
                                "mb-3 text-5 text-uppercase " + (darkTheme ? "text-white" : "")
                            }
                        >
                            {t("contact.address.title")}
                        </h2>
                        <p className={"text-3 mb-4 " + (darkTheme ? "text-light" : "")}>
                            Chihuahua, Chih. México
                        </p>
                        <p className={"text-3 mb-1 " + (darkTheme ? "text-light" : "")}>
              <span className="text-primary text-4 me-2">
                <i className="fas fa-mobile"/>
              </span>
                            (614) 490 0575
                        </p>
                        <p className={"text-3 mb-1 " + (darkTheme ? "text-light" : "")}>
              <span className="text-primary text-4 me-2">
                <i className="fas fa-message"/>
              </span>
                            (614) 609 4589
                        </p>
                        <p className={"text-3 mb-4 " + (darkTheme ? "text-light" : "")}>
              <span className="text-primary text-4 me-2">
                <i className="fas fa-envelope"/>
              </span>
                            <a href="mailto:contacto@alexballesteros.com">contacto@alexballesteros.com</a>
                        </p>
                        <h2
                            className={
                                "mb-3 text-5 text-uppercase " + (darkTheme ? "text-white" : "")
                            }
                        >
                            {t("contact.address.follow_me")}
                        </h2>
                        <ul
                            className={
                                "social-icons justify-content-center justify-content-md-start " +
                                (darkTheme ? "social-icons-muted" : "")
                            }
                        >
                            <li className="social-icons-facebook">
                                <Tooltip text="Facebook" placement="top">
                                    <a
                                        href="https://www.facebook.com/softwaresolutionsmex"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fab fa-facebook-f"/>
                                    </a>
                                </Tooltip>
                            </li>
                            <li className="social-icons-twitter">
                                <Tooltip text="Twitter" placement="top">
                                    <a
                                        href="https://twitter.com/SoftwareSolutMx"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fab fa-twitter"/>
                                    </a>
                                </Tooltip>
                            </li>
                            <li className="social-icons-youtube">
                                <Tooltip text="Youtube" placement="top">
                                    <a
                                        href="https://www.youtube.com/@SoftwareSolutionsMexico"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fab fa-youtube"/>
                                    </a>
                                </Tooltip>
                            </li>
                            <li className="social-icons-instagram">
                                <Tooltip text="Instagram" placement="top">
                                    <a
                                        href="https://www.instagram.com/softwaresolutionsmx"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fab fa-instagram"/>
                                    </a>
                                </Tooltip>
                            </li>
                            <li className="social-icons-github">
                                <Tooltip text="Github" placement="top">
                                    <a
                                        href="https://github.com/software-solutions-mx"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fab fa-github"/>
                                    </a>
                                </Tooltip>
                            </li>
                        </ul>
                    </div>
                    {/* contact form */}
                    <div className="col-md-8 col-xl-9 order-0 order-md-1">
                        <h2
                            className={
                                "mb-3 text-5 text-uppercase text-center text-md-start " +
                                (darkTheme ? "text-white" : "")
                            }
                        >
                            {t("contact.form.title")}
                        </h2>
                        <form
                            className={darkTheme ? "form-dark" : ""}
                            id="contact-form"
                            action="php/mail.php"
                            method="post"
                            ref={form}
                            onSubmit={sendEmail}
                        >
                            <input type="hidden" name="record_source" value={record_source}/>
                            <div className="row g-4 mb-4">
                                <div className="col-xl-6">
                                    <input
                                        name="first_name"
                                        type="text"
                                        className="form-control"
                                        required
                                        placeholder={t("contact.form.first_name")}
                                        value={first_name}
                                        onChange={(e) => setFirstName(e.target.value)}
                                    />
                                </div>
                                <div className="col-xl-6">
                                    <input
                                        name="last_name"
                                        type="text"
                                        className="form-control"
                                        required
                                        placeholder={t("contact.form.last_name")}
                                        value={last_name}
                                        onChange={(e) => setLastName(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="row g-4">
                                <div className="col-xl-6">
                                    <input
                                        name="email"
                                        type="email"
                                        className="form-control"
                                        required
                                        placeholder={t("contact.form.email")}
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <div className="col-xl-6">
                                    <PhoneInput
                                        inputProps={{
                                            name: "mobile_number",
                                            className: "w-100 form-control",
                                        }}
                                        country={"mx"}
                                        placeholder={t("contact.form.phone")}
                                        enableSearch={true}
                                        enableClickOutside={true}
                                        value={mobile_number}
                                        onChange={setMobileNumber}
                                    />
                                </div>
                                <div className="col">
                  <textarea
                      name="message"
                      className="form-control"
                      rows={5}
                      required
                      placeholder={t("contact.form.message")}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                  />
                                </div>
                            </div>
                            <p className="text-center mt-4 mb-0">
                                <button
                                    id="submit-btn"
                                    className="btn btn-primary rounded-pill d-inline-flex"
                                    type="submit"
                                    disabled={isSubmitting}
                                >
                                    {sendingMail ? (
                                        <>
                      <span
                          role="status"
                          aria-hidden="true"
                          className="spinner-border spinner-border-sm align-self-center me-2"
                      ></span>
                                            {t("contact.form.sending")}
                                        </>
                                    ) : (
                                        <>{t("contact.form.send")}</>
                                    )}
                                </button>
                            </p>
                            <ToastContainer/>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
